import { FC, Fragment, MouseEventHandler } from "react";
import { ImgRounded } from "../atoms/ImgRounded";
import { User } from "@/app/auth/auth";

export type ContactListItemProps = {
  user?: User;
  onClick?: MouseEventHandler;
};

export const ContactListItem: FC<ContactListItemProps> = ({
  user,
  onClick,
}) => {
  return (
    <Fragment>
      <li onClick={onClick}>
        <div className="group relative flex items-center px-5 py-6">
          <a className="-m-1 block flex-1 p-1">
            <div
              aria-hidden="true"
              className="absolute inset-0 group-hover:bg-gray-50"
            />
            <div className="relative flex min-w-0 flex-1 items-center">
              <span className="relative inline-block flex-shrink-0">
                <ImgRounded src={user?.avatar} size="extraLarge" />
              </span>
              <div className="ml-4 truncate">
                <p className="truncate text-sm font-medium text-gray-900">
                  {user?.name}{" "}
                  {user?.role !== undefined || null ? (
                    <span className="inline-flex flex-shrink-0 items-center rounded-full bg-green-50 px-1.5 py-0.5 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20 ml-1">
                      {user?.role}
                    </span>
                  ) : (
                    <></>
                  )}
                </p>

                {user?.lastMessage !== undefined || null ? (
                  <>
                    <p className="truncate text-sm text-gray-500">
                      {user?.lastMessage}
                    </p>
                  </>
                ) : (
                  <></>
                )}
                {user?.email !== undefined || null ? (
                  <>
                    <p className="truncate text-sm text-gray-500">
                      {user?.email}
                    </p>
                  </>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </a>
        </div>
      </li>
    </Fragment>
  );
};
